import { SxProps } from "@mui/system";
import { memo, PropsWithChildren } from "react";
import { Box } from "..";
import { createStyles, palette } from "../../../styles/theme";
import { getConditionnalStyle } from "../../../utils/themeUtils";

const styles = createStyles({
  container: {
    display: "flex",
    maxWidth: "fit-content",
    maxHeight: "fit-content",
    padding: "1px 6px 2px 6px",
    alignItems: "center",
    gap: "2px",
    borderRadius: "100px",
    border: "1px solid transparent",
    background: `linear-gradient(90deg, rgba(84, 172, 222, 0.04) 0%, rgba(169, 84, 222, 0.04) 100%), ${palette.lightBorderGradient}`,
    "&>*": {
      fontFamily: "Apercu Pro",
      fontSize: "8px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "normal",
      background: "linear-gradient(90deg, #54ACDE 0%, #A954DE 100%)",
      backgroundClip: "text",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 192dpi)":
      {
        border:
          "0.5px solid transparent" /* Crisp on Retina/high-DPR screens */,
      },
  },
  disabled: {
    "&>*": {
      background: "unset",
      backgroundClip: "unset",
      WebkitBackgroundClip: "unset",
      WebkitTextFillColor: "unset",
    },
  },
});

interface Props {
  sx?: SxProps;
  disabled?: boolean;
}

const GradientChip = (props: PropsWithChildren<Props>) => {
  return (
    <Box
      id="gradient-chip"
      sx={[
        styles.container,
        getConditionnalStyle(!!props.sx, props.sx),
        getConditionnalStyle(props.disabled, styles.disabled),
      ]}
    >
      <span>{props.children}</span>
    </Box>
  );
};

export default memo(GradientChip);
